export default "__VITE_ASSET__DjnTc$LM__"